import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useConversionContext } from '../../../contexts/ConversionProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import CreateConversionAction from './CreateConversionAction';
import FilterConversionDiv from './FilterConversionDiv';

const ShowAllConversions = () => {
  // integration of context hooks here
  const {
    conversionList,
    setTargetedConversion,
    setShowDeleteModal,
    setShowEditModal,
    isError,
    isLoading,
    isSuccess,
  } = useConversionContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions(
    'creditToMinuteConversion'
  );

  // rendering show all conversions section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Minute Conversions'
              additionalComponent={
                <CreateConversionAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterConversionDiv />

              {conversionList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5 px-2'>
                  {conversionList.map((conversion) => (
                    <SetupCard
                      key={conversion.id}
                      title={conversion.name}
                      label={conversion.name}
                      deleteBtnTitle='Delete Minute Conversion'
                      editBtnTitle='Update Minute Conversion'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => {
                              setTargetedConversion(conversion);
                              setShowDeleteModal(true);
                            }
                          : undefined
                      }
                      showEditModalHandler={
                        featureBasedPermissions.includes('UPDATE')
                          ? () => {
                              setTargetedConversion(conversion);
                              setShowEditModal(true);
                            }
                          : undefined
                      }
                    >
                      <div className='border-t border-dashed border-legal-dark-blue pt-1'>
                        <h3 className='text-2xl font-semibold text-base-dark-green italic'>
                          {conversion.minutes_per_credit} Min.
                          <span className='text-sm text-base-orange'>
                            /Credit
                          </span>
                        </h3>

                        <SetupCardBodyInfo
                          label='Description'
                          info={conversion.description}
                        />
                      </div>
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No minute conversions found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load minute conversion data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllConversions;
